/* unplugin-vue-components disabled */import script from "./Package.vue?vue&type=script&setup=true&lang=ts"
export * from "./Package.vue?vue&type=script&setup=true&lang=ts"

import "./Package.vue?vue&type=style&index=0&id=84eac8b0&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84eac8b0"]])

export default __exports__